export default {
  getLastUpdate: (state) => state.lastUpdate,
  getExpectedRecoveryDate: (state) => state.expectedRecoveryDate,
  getUserPermissions: (state) => state.userPermissions,
  getExternalBIMenus: (state) => state.externalBIMenus,
  getExternalBIReports: (state) => state.externalBIMenus.flatMap((m) => m.reports),
}
